import './has-permission.component.ajscss';

import { IComponentOptions } from 'angular';

import { PermissionCtrl } from '../models/abstract-permission-ctrl';
import templateUrl from './has-permission.component.ajs.html';

class HasPermissionCtrl extends PermissionCtrl {}

export class HasPermission implements IComponentOptions {
  templateUrl = templateUrl;
  transclude = true;
  bindings = {
    name: '=',
  };
  controller = ['sessionDeprecatedService', HasPermissionCtrl];
}

export default 'hasPermission';
